<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-tipoendereco') {
            next({ name: 'ven-tipoendereco-list' });
        } else if (to.name == 'agro-tipoendereco') {
            next({ name: 'agro-tipoendereco-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-tipoendereco') {
            this.$router.push({ name: 'ven-tipoendereco-list' });
        } else if (this.$route.name == 'agro-tipoendereco') {
            this.$router.push({ name: 'agro-tipoendereco-list' });
        }
    },
};
</script>
